<template>

    <m-edit1/>

    <m-users-500 v-bind='{...{"moduleName":"MultipleStore","cardName":"mStoreCard317"},...{}}' :style='""' class="my-5" ></m-users-500>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUsers500 from '@moeinmdn/miw-alpha-components/src/package/User/Users/Users500';

export default {
    name: 'HomeView',
    components: {mEdit1, mUsers500 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
